import { IHttpResponse } from "@cirrus/core/http/types"

import { ITranslationsService, LanguageCode, TranslateArgs, Translations } from "./types"

export class TranslationsService implements ITranslationsService {
  constructor(args?: Partial<TranslationsService>) {
    for (const key in args) {
      this[key] = args[key]
    }
  }

  translate = ({ key, language, translations }: TranslateArgs) => {
    try {
      const parts = key.split(":")
      const result = translations?.[language]?.[parts[0]]?.[parts[1]]
      return !result?.trim?.()?.length ? key : result
    } catch (error) {
      console.warn(error)
      return key
    }
  }

  getTranslations = (language: LanguageCode): Promise<IHttpResponse<Translations | null>> =>
    new Promise((resolve) => setTimeout(() => resolve({ data: null, status: 200, statusText: "OK" }), 1000))

  persistLanguage = (language: LanguageCode) => sessionStorage.setItem("urlLang", language)

  getDefaultLanguage = (): LanguageCode => "en-GB"
}
